import { Pagination as PomodoroPagination } from '@ifood/pomodoro-components';
import { useIntl } from 'gatsby-plugin-intl';
import React, { useCallback } from 'react';

import { DEFAULT_PAGE_SIZE } from '../../constants';

type PropTypes = {
  // TODO:: we will remove this later when pomodoro fixes their type exports
  position?: 'right' | 'left' | 'center';
  current: number;
  totalItems?: number;
  nextLabel?: string;
  previousLabel?: string;
  ofLabel?: string;
  showingLabel?: string;
  onChange: (pageNumber: number) => void;
  pageSize?: number;
};

// TODO:: we will remove this later when pomodoro fixes their type exports
type PaginationChangeData = {
  currentPage: number;
  nextOffset: number;
  previousOffset: number;
};

const Pagination = ({
  position = 'right',
  current,
  totalItems = 0,
  nextLabel,
  previousLabel,
  ofLabel,
  showingLabel,
  pageSize = DEFAULT_PAGE_SIZE,
  onChange,
}: PropTypes): JSX.Element => {
  const { formatMessage } = useIntl();

  const handleClick = useCallback(({ currentPage }: PaginationChangeData) => onChange(currentPage - 1), [onChange]);

  return (
    <PomodoroPagination
      pageSize={pageSize}
      current={current + 1}
      totalItems={totalItems}
      nextLabel={nextLabel || formatMessage({ id: 'next' })}
      previousLabel={previousLabel || formatMessage({ id: 'previous' })}
      ofLabel={ofLabel || formatMessage({ id: 'pagination.in' })}
      showingLabel={showingLabel || formatMessage({ id: 'pagination.display' })}
      position={position}
      onChange={handleClick}
    />
  );
};

export default Pagination;
